import { render, staticRenderFns } from "./BalanceBadDebts.vue?vue&type=template&id=8f400b66&"
import script from "./BalanceBadDebts.vue?vue&type=script&lang=js&"
export * from "./BalanceBadDebts.vue?vue&type=script&lang=js&"
import style0 from "./BalanceBadDebts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports